import { render, staticRenderFns } from "./IconUmbrella.vue?vue&type=template&id=7526a228&"
import script from "./IconUmbrella.vue?vue&type=script&lang=js&"
export * from "./IconUmbrella.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports